import type { SimplifiedCookieAttributes as CookieAttributes } from '../types/cookie';
import { cookie } from './cookie';
import { ls } from './local-storage';

// TODO: storage は最終的に intervalDaysToExpiration を private なプロパティとして持つクラスにする
// というのも、storage.set するたび当該引数を渡しているという事実に些かの無駄を感じるからである
export const storage = {
  get: (key: string, { asJSON = false } = {}): any => {
    const fromCookie = asJSON ? cookie.getJSON(key) : cookie.get(key);
    if (fromCookie !== undefined) return fromCookie;

    const fromLocalStorage = ls.get(key);
    if (!asJSON) return fromLocalStorage;
    if (!fromLocalStorage) return {};
    try {
      // check if value from localStorage is JSON like object: e.g. { sound: 'euphonium' }
      // ref. https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/JSON/parse#Throws
      return JSON.parse(fromLocalStorage);
    } catch (error) {
      console.warn(error);
      return {};
    }
  },

  set: (key: string, value: any, options: CookieAttributes = {}) => {
    cookie.set(key, value, options);

    const stringifiedValue = typeof value === 'object' ? JSON.stringify(value) : value;
    const expiresValue = options.expires;
    ls.set(key, stringifiedValue, { expires: expiresValue });
  },

  remove: (key: string, options?: CookieAttributes) => {
    cookie.remove(key, options);
    ls.remove(key);
  },

  removeReproEntries: (options?: CookieAttributes) => {
    cookie.removeReproEntries(options);
    ls.removeReproEntries();
  },

  get isAvailable(): boolean {
    return cookie.isAvailable && ls.isAvailable;
  },
};
